module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai120-aaeb2826409e8a6b0657c62e19bfc6e9.jpg";